import getURLParams from 'utils/DOM/getURLParams'

const parametersToRead = [
  // Common parameters for flow between pages
  'session_id',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'zip',
  'county',
  'fname',
  'lname',
  'gender',
  'dob',
  'email',
  'spouse',
  'dob_s',
  'gender_s',
  'phone_number',
  'coverage',
  'period',
  'planid',
  'policies',
  'sdate',
  'endDate',
  // Marketing parameters
  'src',
  'fid',
  'sd1',
  'sd2',
  'sd3',
  'sd4',
  'sd5',
  'md',
  'pb',
  'cmp',
  'adg',
  'kwid',
  'kt',
  'mt',
  'cr',
  'ce',
  'cp',
  'pd',
  'os',
  'pl',
  'pl_zip',
  'pl_st',
  'ref',
  'cc',
  'cl',
  'fbclid',
  'tb',
  'hs',
  'hi',
  'qle',
  'qs',
  'ag',
  'lid',
  'ins',
  'inc',
  'tkn'
] as const

export type ParameterToRead = typeof parametersToRead[number]

const pickParameters = (
  parameters: Record<string, string>,
  pick: Array<ParameterToRead>
) => {
  let result: null | Record<ParameterToRead, string> = null
  for (const key of pick)
    if (parameters[key]) {
      if (!result) result = {} as Record<ParameterToRead, string>
      result[key] = parameters[key]
    }

  return result
}

const createBrowserNode = queryParams => {
  let browserNode = pickParameters(queryParams, [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content'
  ])

  const marketingParameters = pickParameters(queryParams, [
    'src',
    'fid',
    'sd1',
    'sd2',
    'sd3',
    'sd4',
    'sd5',
    'md',
    'pb',
    'cmp',
    'adg',
    'kwid',
    'kt',
    'mt',
    'cr',
    'ce',
    'cp',
    'pd',
    'os',
    'pl',
    'pl_zip',
    'pl_st',
    'ref',
    'cc',
    'cl',
    'fbclid',
    'tb',
    'hs',
    'hi',
    'qle',
    'qs',
    'ag',
    'lid',
    'ins',
    'inc',
    'tkn'
  ])
  if (marketingParameters)
    browserNode = {
      ...browserNode,
      marketing: marketingParameters
    }

  return browserNode
}

export default function readFromQueryParameters(): Pivot.Session | undefined {
  const queryParams = getURLParams()

  const existData = parametersToRead.some(param => queryParams[param])

  if (!existData) {
    return undefined
  }

  return {
    sessionId: queryParams.session_id,
    user: pickParameters(queryParams, [
      'fname',
      'lname',
      'email',
      'phone_number',
      'gender',
      'dob',
      'gender_s',
      'dob_s'
    ]),
    browser: createBrowserNode(queryParams),
    quote: pickParameters(queryParams, [
      'zip',
      'county',
      'coverage',
      'period',
      'planid',
      'policies',
      'sdate',
      'endDate'
    ]),
    cart: null,
    createdAt: null,
    updatedAt: null,
    expiresAt: null
  }
}
